import { RuleTableConfiguration } from "../../../../../rule-engine-core/Rule/Table/Rule/RuleTableConfiguration";
import type {
    DemoRuleIntegrationAdapter,
    RuleConfigFactoryContext,
    RuleDemoDataProjectionPort,
    RuleEvaluatorPort,
    RulePolicyBinding,
    RuleRowMapperPort,
    RuleSummaryPresenterPort,
} from "../../ruleIntegrationTypes";
import { identityRuleRowMapper } from "../../ruleIntegrationTypes";
import type { RuleSuggestionCommandPort } from "../../../application/ports/RuleSuggestionCommandPort";
import { withExecutableRuntimeEvidence } from "../runtimeEvidence";
import { ruleTableStorageCodec } from "../storageCodecs";

export const RULE_TABLE_EXECUTABLE_TYPE = "RuleTableConfiguration";

export type CreateRuleTableIntegrationAdapterParams<DemoRow, RuntimeRow = DemoRow> = {
    ruleId: string;
    policyBinding?: RulePolicyBinding;
    createConfig: (context?: RuleConfigFactoryContext) => RuleTableConfiguration;
    rowMapper?: RuleRowMapperPort<DemoRow, RuntimeRow>;
    evaluator: RuleEvaluatorPort<RuleTableConfiguration, RuntimeRow>;
    summaryPresenter: RuleSummaryPresenterPort<RuleTableConfiguration>;
    demoDataProjection?: RuleDemoDataProjectionPort<RuleTableConfiguration>;
    suggestionCommands?: RuleSuggestionCommandPort<RuleTableConfiguration>;
};

export const createRuleTableIntegrationAdapter = <DemoRow, RuntimeRow = DemoRow>({
    ruleId,
    policyBinding,
    createConfig,
    rowMapper,
    evaluator,
    summaryPresenter,
    demoDataProjection,
    suggestionCommands,
}: CreateRuleTableIntegrationAdapterParams<DemoRow, RuntimeRow>): DemoRuleIntegrationAdapter<
    RuleTableConfiguration,
    DemoRow,
    RuntimeRow
> => ({
    ruleId,
    status: "adapter_backed",
    appGlueExecutableType: RULE_TABLE_EXECUTABLE_TYPE,
    editorSurface: "native_rule_table_builder",
    policyBinding,
    ports: {
        configFactory: { createConfig },
        storageCodec: ruleTableStorageCodec(),
        rowMapper: rowMapper ?? (identityRuleRowMapper<DemoRow>() as unknown as RuleRowMapperPort<DemoRow, RuntimeRow>),
        evaluator: withExecutableRuntimeEvidence(RULE_TABLE_EXECUTABLE_TYPE, evaluator),
        summaryPresenter,
        demoDataProjection,
        suggestionCommands,
    },
});
